import Builder from './xpath-builder';
import { requestFieldMapper } from './request-mapper';

/**
 * Builds an xpath string for one particular field by calling
 * its builder function.
 * @param {*} key - the attribute key
 * @param {*} value - the attribute value
 * @param {*} xpath - the overall xpath being built for
 * the response
 * @param {*} data - the request data
 * @return - an xpath for the attribute or a callback function
 */
export function buildXpathForField({ key, value, ...rest }) {
  // Get the attribute object containing name + function
  const attrObj = requestFieldMapper(key);
  if (!attrObj) return null;

  const { attribute, builderFunction } = attrObj;

  // return the response from the attributes function
  return builderFunction({ attribute, value, ...rest });
}

/**
 * Entry point to xpath query builder middleware. Takes the JSON
 * payload from the request body, processes the payload, and
 * returns a complete xpath.
 * @param {*} data
 * @return
 */
export function buildXpathFromPayload(data) {
  const builder = new Builder();
  const callbacks = [];
  let alternateId = null
  Object.entries(data).forEach(([key, value]) => {
    try {
      const attributePath = buildXpathForField({
        key,
        value,
        xpath: builder.xpath,
        data,
      });

      //console.log("key->" + key, attributePath);

      if (attributePath) {
        if (typeof attributePath === 'string') {
          switch (key) {
            default :
              return builder.xpath
                ? builder.and(builder.xpath, attributePath)
                : builder.set(attributePath);

          }
        }
        return callbacks.push(attributePath);
      } else if (key === 'alternateId') {
        alternateId = value;
      }

    } catch (error) {
      throw new Error('An error occurred while trying to compose an Xpath.');
    }
    // appease linter
    return {};
  });

  callbacks.forEach((cb) => {
    builder.xpath = cb({ xpath: builder.xpath, data });
  });

  /**
   * AJG: add alternateId to the xpath, this is a hack to get around the fact that the queries
   * are generally malformed.
   */
  if (alternateId) {
    builder.xpath +=  ` OR (/FullMetadata/BaseObjectData/AlternateID "${alternateId}")`
  }

  return builder.xpath;
}
